import { BaseColumnModel } from '~components/dynamic-table/models/column-types/base-column.model';
import { StringColumnModel } from '~components/dynamic-table/models/column-types/string-column.model';

export const industrySelectionTableConfig: BaseColumnModel[] = [
    new StringColumnModel({
        propertyName: 'title',
        columnTitleKey: 'General.Industry'
    })
];
